import type { FC, SVGProps } from "react";
import { BuildingsLinear, FileTextLinear, FolderWithFilesLinear, UsersGroupTwoRoundedLinear } from "solar-icon-set";
import type { ScopeIconSize, ScopeType } from "./ScopeIcon.types";

type IconComponent = FC<SVGProps<SVGSVGElement> & { size?: number; color?: string }>;

interface ScopeIconConfig {
  Icon: IconComponent;
  iconColor: string;
  bgClass: string;
}

export const SCOPE_ICON_CONFIG: Record<ScopeType, ScopeIconConfig> = {
  TEAM: {
    Icon: UsersGroupTwoRoundedLinear,
    iconColor: "var(--color-icon-secondary-usual)",
    bgClass: "bg-(--color-bg-container-pop-faint)",
  },
  PROJECT: {
    Icon: BuildingsLinear,
    iconColor: "var(--color-icon-soft-usual)",
    bgClass: "bg-(--color-bg-container-soft-faint)",
  },
  FOLDER: {
    Icon: FolderWithFilesLinear,
    iconColor: "var(--color-icon-primary-usual)",
    bgClass: "bg-(--color-bg-container-primary-faint)",
  },
  FILE: {
    Icon: FileTextLinear,
    iconColor: "var(--color-default-500)",
    bgClass: "bg-(--color-bg-container-surface-faint)",
  },
};

/** Icon sizes in pixels */
export const ICON_SIZES: Record<ScopeIconSize, number> = {
  sm: 16,
  md: 20,
  lg: 24,
};

/** Container sizes in Tailwind classes */
export const CONTAINER_SIZES: Record<ScopeIconSize, string> = {
  sm: "h-6 w-6",
  md: "h-7 w-7",
  lg: "h-8 w-8",
};
